export default {
	mainHeaderMenu: {
		notifications: 'MELDUNGEN',
		approvalList: 'PRÜFINHALTE',
		softwareSystemList: 'SYSTEME'
	}
}
